<template>
    <Checkbox v-model="checked" value="1" :binary="true" @change="onChanged"></Checkbox>
</template>
<script>
import Checkbox from 'primevue/checkbox';
import { PwgsApi } from '../../../services/PwgsApi';

export default {
    components: {
        Checkbox
    },
    props: [
        'props',
        'datos',
    ],
    data() {
        return {
            checked: false
        }
    },
    methods: {
        async cambiarEstado(){
            
            /*  modulos/pwgsapi/index.php/usuarios/:id/estado */
            const api = new PwgsApi;
            const subidadatos = {estado_usuario:'activo'};
            
            if (this.checked == true) {
                subidadatos.estado_usuario = 'ausente';
            }
            else {
                subidadatos.estado_usuario = 'activo';
            }
            try {
               await api.put('usuarios/' + this.datos.idusuario + '/estado', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                this.$emit('cambioAusente', this.checked);
            }
            catch (error) {
                alert(error);
                this.checked = !this.checked;
            }
        },
        confirmar(){
            var str = this.checked == true ? 'ausente' : 'activo';
            this.$confirm.require({
                message: '¿Seguro que quieres cambiar al usuario a estado: ' + str + '?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.cambiarEstado();
                },
                reject: () => {
                    this.checked = !this.checked;
                    return;
                }
            });
        },
       onChanged() {
            this.confirmar();            
        }
    },
    mounted() {
        const datos = this.datos;
        this.checked = this.props.checked(datos);
    }
}
</script>